// Free-text rules every contract shares. A leaf module: it imports nothing, so
// a schema file of any module can take it without forming an import cycle.

/**
 * True when a string holds no NUL character (U+0000). Postgres text cannot
 * hold one, and jsonb refuses the `\u0000` escape, so free text carrying one
 * would pass a contract and end as a database 500. Every free-text field that
 * reaches a text or jsonb column refuses it as 400 `VALIDATION_FAILED` with
 * the reason `nul_character`: a saved view's name and `q`, a customer note's
 * body, the customer's `notes` alias that writes one, and a tag name.
 */
export function textHasNoNul(value: string): boolean {
  return !value.includes("\u0000");
}

/** The issue `textHasNoNul` raises, passed to zod's `refine`, which adds no
 * `pattern` to the published schema. */
export const NUL_ISSUE = {
  message: "a NUL character (U+0000) cannot be stored",
  params: { reason: "nul_character" },
} as const;
